/**
 * Created by work on 17/1/10.
 */
import {REFRESH_REPORT, REFRESH_TAB} from '../actions/report';

const initState = {
  reportData: null,
  tabIndex: true
};

export default (state = initState, action) => {
  switch (action.type) {
    case REFRESH_REPORT: {
      const {reportData} = action;
      return Object.assign({}, state, {reportData});
    }
    case REFRESH_TAB: {
      return Object.assign({}, state, {tabIndex: action.tabIndex});
    }
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/report.js